import type { FC, HTMLProps } from 'react'

import useTranslation from '@/hooks/useTranslation'
import { twMerge } from '@/utils/tailwind'

interface SourceFileProps extends HTMLProps<HTMLParagraphElement> {
  file: File;
}

const SourceFile: FC<SourceFileProps> = ({ file, className }) => {
  const { t } = useTranslation()

  return (
    <p className={twMerge('tw-max-w-full lg:tw-max-w-3/5 tw-text-xl tw-font-semibold tw-text-ui-black tw-break-all', className)}>
      {t('pdfextra_convert_tool.target_formats.source_file')} {file.name}
    </p>
  )
}

export default SourceFile
